"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAll = fetchAll;
exports.legacyFetchActiveOwners = legacyFetchActiveOwners;
exports.updateOwner = updateOwner;
exports.fetchCurrentOwner = fetchCurrentOwner;
exports.fetchByEmailFlat = fetchByEmailFlat;
exports.fetchByEmail = fetchByEmail;
exports.fetchById = fetchById;
exports.fetchByIds = fetchByIds;
exports.fetchByRemoteIdFlat = fetchByRemoteIdFlat;
exports.fetchByRemoteId = fetchByRemoteId;
exports.searchOwners = searchOwners;
exports.searchOwnersBatch = exports.fetchByRemoteIds = exports.fetchByEmails = exports.BASE_PATH = void 0;

var _Identifiable = require("customer-data-objects/protocol/Identifiable");

var _immutable = require("immutable");

var ImmutableAPI = _interopRequireWildcard(require("../api/ImmutableAPI"));

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _makeBatch = _interopRequireDefault(require("../api/makeBatch"));

var _OwnerRecord = _interopRequireDefault(require("customer-data-objects/owners/OwnerRecord"));

var _PaginatedSearchResponse = _interopRequireDefault(require("customer-data-objects/search/PaginatedSearchResponse"));

var _Raven = _interopRequireDefault(require("Raven"));

var BASE_PATH = 'owners/v2/owners';
exports.BASE_PATH = BASE_PATH;

function fetchAll() {
  return ImmutableAPI.get("" + BASE_PATH, {
    includeSignature: false
  }, function (owners) {
    return (0, _immutable.List)(owners.map(_OwnerRecord.default.fromJS));
  });
}

function legacyFetchActiveOwners() {
  return fetchAll().then(_Identifiable.indexByIdString);
}

function updateOwner(owner) {
  var ownerId = owner.get('ownerId');
  return ImmutableAPI.put(BASE_PATH + "/id/" + ownerId, owner);
}

function fetchCurrentOwner() {
  return ImmutableAPI.get(BASE_PATH + "/current/remotes", undefined, _OwnerRecord.default.fromJS).catch(function (error) {
    // a 404 means this is a JITA user
    if (error.status === 404) {
      return _LoadingStatus.EMPTY;
    }

    throw error;
  });
}

function fetchByEmailFlat(email) {
  var error = new Error('OwnersAPI#fetchByEmailFlat - owner resolved via email alias');
  return ImmutableAPI.get(BASE_PATH + "/email/" + email, {
    includeSignature: false
  }, function (owners) {
    return _OwnerRecord.default.fromJS(owners[0]);
  }).then(function (owner) {
    // Temporarily added to identify all stores/components using this API
    // https://git.hubteam.com/HubSpot/CRM-Issues/issues/3545
    if (!email || !owner.get('email')) {
      return owner;
    }

    if (email.toUpperCase() !== owner.get('email').toUpperCase()) {
      _Raven.default.captureException(error, {
        extra: {
          emailAlias: email,
          ownerEmail: owner.get('email')
        }
      });
    }

    return owner;
  });
}

var fetchByEmails = (0, _makeBatch.default)(fetchByEmailFlat, 'OwnersAPI.fetchByEmailFlat');
exports.fetchByEmails = fetchByEmails;

function fetchByEmail(email) {
  return fetchByEmailFlat(email).then(function (owner) {
    return _immutable.List.of(owner);
  });
}

function fetchById(ownerId) {
  return ImmutableAPI.get(BASE_PATH + "/" + ownerId, {
    includeSignature: false
  }, _OwnerRecord.default.fromJS);
}

function fetchByIds(ownerIds) {
  return ImmutableAPI.get(BASE_PATH + "/batch", {
    includeSignature: false,
    ownerId: ownerIds.valueSeq().toJS()
  }, function (json) {
    return (0, _immutable.Map)(json).map(_OwnerRecord.default.fromJS);
  });
}

function fetchByRemoteIdFlat(remoteId) {
  return ImmutableAPI.get(BASE_PATH + "/remoteId/" + remoteId, {
    includeSignature: false
  }, function (owners) {
    return _OwnerRecord.default.fromJS(owners[0]);
  });
}

var fetchByRemoteIds = (0, _makeBatch.default)(fetchByRemoteIdFlat, 'OwnersAPI.fetchByRemoteIdFlat');
exports.fetchByRemoteIds = fetchByRemoteIds;

function fetchByRemoteId(remoteId) {
  return fetchByRemoteIdFlat(remoteId).then(function (owner) {
    return _immutable.List.of(owner);
  });
}

var fromElasticSearch = _PaginatedSearchResponse.default.fromElasticSearch({
  getHasMore: function getHasMore(response) {
    return response.hasMore;
  },
  getObjects: function getObjects(response) {
    return response.results;
  },
  getTotal: function getTotal(response) {
    return response.hasMore ? response.total : response.results.length;
  },
  getObjectId: function getObjectId(owner) {
    return owner.ownerId;
  },
  objectFromJS: _OwnerRecord.default.fromJS
});

function searchOwners(searchQuery) {
  var count = searchQuery.count,
      offset = searchQuery.offset,
      query = searchQuery.query;
  return ImmutableAPI.get(BASE_PATH + "/search", {
    limit: count,
    offset: offset,
    search: query
  }, fromElasticSearch(searchQuery));
}

var searchOwnersBatch = (0, _makeBatch.default)(searchOwners, 'OwnersAPI.searchOwners');
exports.searchOwnersBatch = searchOwnersBatch;